import { Component, ViewEncapsulation, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ap-full-screen-dialog',
  templateUrl: './full-screen-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullScreenDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { contentId: string, robotId: string }) { }

}
